import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Navbar from "../Navbar";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@mui/material/Autocomplete";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { Fragment, useMemo, useRef } from "react";
import ColumnFilter from "../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
// import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import axios from "axios";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Formik, useFormik } from "formik";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { withRouter } from "react-router-dom";
import BlockIcon from "@mui/icons-material/Block";
import { Backdrop, InputAdornment, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import { common_axios } from "../../../App";
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import SettingsBackupRestoreRoundedIcon from "@mui/icons-material/SettingsBackupRestoreRounded"
import Swal from "sweetalert2";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {
  useAsyncDebounce,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import * as yup from "yup";
import Loader from "../../../components/Loader";

function Credit({resetValue}) {
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
        },
      },
    },
  });
  const [hide, setHide] = useState(true);

  const [open, setOpen] = useState();
  const [fetchData, setFetchData] = useState([]);
  const[hideSkeleton,setHideSkeleton]= useState()

  const customId1 = "custom-id-yess";
  const[uid,setUid]=useState("")
  // console.log("uid----",uid)
  const [data, setData] = useState([]);
const[username,setUsername] =useState();
  const top100Films = [
    { label: "English", year: 0 },
    { label: "Bangladesh", year: 1 },
  ];

 // .....................................Formik............................................//
 const initialValues = {
  amount: "",
  // phonebookDescription: "",
};
const regex = /^[1-9][0-9]{0,6}$|^10000000$/
const validationSchema = yup.object({
  amount: yup
    .string()
    // .min(3, "Please enter atleast 3 digits in amount")
    //  .max(10000000, "Amount Should be less than 1 crore")
    .matches(regex,"Amount Should be less than 1 crore")
    .required("Required"),
});


const formik = useFormik({
  initialValues: initialValues,                        

  onReset: (initialValues) => ({                                        
    values: { initialValues },                                                                     
  }),
  validationSchema: validationSchema,                                             
  onSubmit: (values) => {                 
    SavePost(values);          
  },
});
   async function CreditPost() {
  // setOpen(true);
  try {
    setHideSkeleton(true)

    const result = await common_axios(
      `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/recharge/v1/fetch/user/details`,
    );

    // console.log("------resultssss", result);
    if (result.data.statusDescription.statusCode == 200) {
      // setOpen(false);
      setHideSkeleton(false)

      setFetchData(result.data.userDetails)
    } else {
      // setOpen(false);
      setHideSkeleton(false)

      // toast.error(result.data.statusDescription.statusMessage);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: result.data.statusDescription.statusMessage,
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  } catch (error) {
    // setOpen(false);
    setHideSkeleton(false)

    // toast.error("Please Check Your Network");
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Please Check Your Network",
      // footer: '<a href="">Why do I have this issue?</a>'
    });
  }
}
// const UserId = localStorage.getItem("UserId");


async function SavePost(values) {
  
  setOpen(true);
  try {
    const result = await common_axios.post(
      `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/recharge/v1/save/details`,{
        "rechargeRequest":{
          // userId:localStorage.getItem("UserId"),
          uid:uid.uid,
          amount:values.amount,
          username: localStorage.getItem("usernamedisplayed")
      }
      }
    );

    // console.log("------resultssss", result);
    if (result.data.statusDescription.statusCode == 200) {
      setOpen(false);
      formik.handleReset();
      setHide(false);
      setUid()
      setData([...data,
        {
          amount:values.amount,
          username:uid.username,
        },
        
       ]);
        Swal.fire({
          icon: "success",
          //  title: "Oops...",
          text: "Success",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
    } else {
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: result.data.statusDescription.statusMessage,
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  } catch (error) {
    setOpen(false);

    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Please Check Your Network",
      // footer: '<a href="">Why do I have this issue?</a>'
    });
  }
}
useEffect(()=>{
  CreditPost()
},[])
  // --------------------------------------Table-----------------------------
  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const modelButtonReject = useRef(null);
  const modelButtonApprove = useRef(null);

  const columns = useMemo(
    () => [
      {
        Header: "Username",
        accessor: "username",
      },
      {
        Header: "Amount",
        accessor: "amount", // accessor is the "key" in the data
      },

    
     
    ],
    []
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );
  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);
  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };
  const changeOrder = () => {
    setColumnOrder(["id", "username", "action", "role", "email"]);
  };
  const uploadreset = () => {
    setUid("");
    formik.handleReset()
  };

  useEffect(() => {
    setUid("");
    formik.handleReset()
  }, [resetValue]);
  // ------------------------------------End Table-------------------------------
  return (
    <>
      <main className="main-content position-relative border-radius-lg ">
      <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        
                  <div className="row">
            <div className="col-xl-12 col-sm-12 mb-xl-0 mb-4">
             
                 
               
                  <div className="text-end pt-1">
                  <div className="card-body">
          <div className="card shadow-none border bg_blue mt-4">
            <span className="badge rounded-pill bg-primary mt-n3 ms-5">
              {/* Add Number */}
             Credit Allocation
            </span>
            <ThemeProvider theme={theme}>

            <div className="card-body text-lg-start text-center">
            <form
                          onSubmit={formik.handleSubmit}
                          role="form"
                          // className="text-start"
                        >
            <div class="row">

            <div class="col-md-4">
            {
  hideSkeleton==true?(<> <Box sx={{ width: "100%"}}>
      <Skeleton />
      <Skeleton animation="wave" />
      {/* <Skeleton animation={false} /> */}
    </Box>
</>):(<>    

   <Autocomplete
      disablePortal
      aria-required
      className="w-100"
      id="combo-box-demo"
      size="small"
      required
      options={fetchData}
      getOptionLabel={(option) => option?.username || ""}
       value={uid}
      // onChange={(e, value) => handlechange(value)}
      onChange={(e,value)=>{
        //   setlist(value);
        setUid(value);
        // setUsername(value?.username)
        }}
      sx={{ width: 300 }}
      renderInput={(params) => (
        <TextField required {...params} label="User Details" />
      )}
    />
    
    </>)}
     
    
            </div>
            <div class="col-md-4">
           <TextField
                                    className="ms-4 w-100"
                                    style={{
                                      borderRadius: "4px",
                                    }}
                                    type="number"
                                    label="Amount Enter"
                                    name="amount"
                                    variant="outlined"
                                    size="small"
                                    required
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <Tooltip
                                            title="Amount Enter"
                                            placement="top"
                                            arrow
                                            sx={{ color: "#85CBF2" }}
                                          >
                                            <InfoIcon />
                                          </Tooltip>
                                        </InputAdornment>
                                      ),
                                    }}
                                    onChange={formik.handleChange}
                                  value={formik.values.amount}
                                  error={
                                    formik.touched.amount &&
                                    Boolean(formik.errors.amount)
                                  }
                                  helperText={
                                    formik.touched.amount &&
                                    formik.errors.amount
                                  }
                        onInput={(e) => {
                              e.target.value = e.target.value
                                .toString()
                                .slice(0, 8);
                            }}
                                  />
           </div>
</div>
           <div className="d-flex justify-content-between mt-3"> 
                          
                          <button
                      //  onClick={formik.resetForm}
                      type="button"
                      className="btn resetBtn_UP ms-2 w_btn btn_w8 m-0"
                       onClick={uploadreset}
                    >
                      Reset
                      {/* <SettingsBackupRestoreRoundedIcon style={{fontSize:"17px"}}/> */}
                    </button>

                    <button
                            type="submit"
                            class="btn green_UP text-capitalize d-block  m-0"
                          >
                            save
                            {/* <ArrowForwardIcon style={{ fontSize: "17px" }}/> */}

                          </button>


                    </div>
                    </form>
            </div>
            </ThemeProvider>
          </div>
          {/* ------------------------------------Table------------------------------- */}
{
  hide == true ?(<></>):(<>
    <div>
              <div className="card shadow-none border bg_blue mt-5">
                    <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                     Credit Allocation List
                    </span>
                    <div className="card-body text-lg-start text-center">
                {selectedUserDetail != undefined && (
                  <div>
                    <button
                      ref={modelButtonReject}
                      type="button"
                      className="btn btn-primary d-none"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                    >
                      Launch static backdrop modal
                    </button>
                    <div
                      className="modal fade"
                      id="staticBackdrop"
                      data-bs-backdrop="static"
                      data-bs-keyboard="false"
                      tabindex="-1"
                      aria-labelledby="staticBackdropLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5
                              className="modal-title"
                              id="staticBackdropLabel"
                            >
                              Reject User
                            </h5>
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div className="modal-body">
                            <div>
                              <label>
                                Rejected Reason
                                <input
                                  type="text"
                                  value={selectedUserDetail.rejectedReason}
                                  onChange={(e) => {
                                    setSelectedUserDetail({
                                      ...selectedUserDetail,
                                      rejectedReason: e.target.value,
                                    });
                                  }}
                                />
                              </label>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              data-bs-dismiss="modal"
                            >
                              Close
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary"
                              data-bs-dismiss="modal"
                              onClick={() => {
                                // rejectUserApi();
                              }}
                            >
                              Reject User
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {selectedUserDetailApprove != undefined && (
                  <div>
                    <button
                      ref={modelButtonApprove}
                      type="button"
                      className="btn btn-primary d-none"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop1"
                    >
                      Launch static backdrop modal
                    </button>
                    <div
                      className="modal fade"
                      id="staticBackdrop1"
                      data-bs-backdrop="static"
                      data-bs-keyboard="false"
                      tabindex="-1"
                      aria-labelledby="staticBackdrop1Label"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5
                              className="modal-title"
                              id="staticBackdrop1Label"
                            >
                              Approve User
                            </h5>
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div className="modal-body">
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              data-bs-dismiss="modal"
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary"
                              data-bs-dismiss="modal"                             
                              onClick={() => {            
                                // approveUserApi();
                              }}  
                            >
                              Approve User
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
             
                      <div>
                        {selectedFlatRows.length > 0 && (
                          <button onClick={deletUser}>Delete Users</button>
                        )}
                      </div>
                      <table
                        {...getTableProps()}
                        id="example"
                        className="table table-striped table-bordered dataTable table-sm"
                        style={{ width: "100%" }}
                      >
                        <thead>
                          {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                              {headerGroup.headers.map((column) => (
                                <th
                                  {...column.getHeaderProps(
                                    column.getSortByToggleProps()
                                  )}
                                  className="text-center width_2"
                                >
                                  {column.render("Header")}
                                  <span>
                                    {column.isSorted
                                      ? column.isSortedDesc
                                        ? "↑"
                                        : "↓"
                                      : ""}
                                  </span>
                                </th>
                              ))}
                            </tr>
                          ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                          {page.map((row) => {
                            prepareRow(row);
                            return (
                              <tr {...row.getRowProps()}>
                                {row.cells.map((cell) => {
                                  return (
                                    <td
                                      {...cell.getCellProps()}
                                      className="text-center"
                                    >
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
  </>)
}
        </div>
                  </div>
            </div>
          </div>
      </main>
    </>
  );
}

export default withRouter(Credit);
